module.exports = __webpack_public_path__ + "static/media/premium_start.9bf8d604.png";